export const fallbackNews = [
  {
    id: 'news-001',
    date: '2026.05',
    title: 'Pendaftaran kelas persiapan kerja gelombang baru',
    description: 'Informasi jadwal, syarat peserta, dan tahapan seleksi dapat diperbarui di area ini.',
    content: 'Gunakan dashboard admin untuk mengganti isi berita ini dengan pengumuman resmi Furusato.',
    imageUrl: '',
  },
  {
    id: 'news-002',
    date: '2026.05',
    title: 'Kegiatan pembinaan budaya kerja dan kedisiplinan',
    description: 'Ringkasan kegiatan pelatihan, dokumentasi, atau pengumuman resmi Furusato.',
    content: 'Konten lengkap berita dapat berisi dokumentasi kelas, agenda pelatihan, dan informasi untuk peserta.',
    imageUrl: '',
  },
];

export const fallbackGallery = [
  {
    id: 'gallery-001',
    title: 'Ruang kelas bahasa Jepang',
    description: 'Dokumentasi kelas bahasa dan komunikasi kerja.',
    imageUrl: '',
  },
  {
    id: 'gallery-002',
    title: 'Workshop keterampilan kerja',
    description: 'Dokumentasi praktik keterampilan dan simulasi kerja.',
    imageUrl: '',
  },
  {
    id: 'gallery-003',
    title: 'Simulasi wawancara dan budaya kerja',
    description: 'Dokumentasi pembinaan karakter dan persiapan seleksi.',
    imageUrl: '',
  },
];

export const fallbackLulusJobs = [
  {
    id: 'lulus-job-001',
    name: 'Siswa Lulus 1',
    origin: 'Temanggung',
    quote: 'Terima kasih Furusato, saya jadi lebih siap bekerja dan lebih percaya diri.',
    imageUrl: '',
  },
  {
    id: 'lulus-job-002',
    name: 'Siswa Lulus 2',
    origin: 'Wonosobo',
    quote: 'Pembinaan dan latihan di Furusato membantu saya sampai ke tahap kerja.',
    imageUrl: '',
  },
  {
    id: 'lulus-job-003',
    name: 'Siswa Lulus 3',
    origin: 'Magelang',
    quote: 'Ilmu bahasa dan budaya kerja sangat berguna saat memasuki dunia kerja Jepang.',
    imageUrl: '',
  },
];

export const fallbackSite = {
  brandName: 'LPK FURUSATO TEMANGGUNG',
  brandSubtitle: 'Lembaga Pelatihan Kerja',
  logoUrl: 'https://res.cloudinary.com/dlmpca80t/image/upload/v1793727436/furusato/x1cm4jwf4bobandoatt5.png',
  backgrounds: {
    homeHeroUrl: '',
    homeAboutUrl: '',
    homeNewsUrl: '',
    aboutPageUrl: '',
    galleryPageUrl: '',
    lulusJobPageUrl: '',
    contactPageUrl: '',
  },
  address: 'Temanggung, Jawa Tengah, Indonesia',
  phone: '+62 000 0000 0000',
  email: 'info@furusato.co.id',
  whatsapp: 'https://wa.me/6200000000000',
  socials: {
    instagram: 'https://instagram.com/',
    facebook: 'https://facebook.com/',
    youtube: 'https://youtube.com/',
    tiktok: 'https://tiktok.com/',
  },
};

export const fallbackHomeContent = {
  heroBackgroundUrl: '',
  jobInfo: {
    label: 'Info Job',
    title: 'Info Job',
    description: 'Ringkasan peluang kerja terbaru, jadwal seleksi, dan bidang kerja yang sedang dibuka.',
    linkUrl: '/berita',
  },
  jobBanner: {
    label: 'Info Job',
    title: 'Informasi Job Terbaru',
    description: 'Update peluang kerja, seleksi, dan kelas persiapan akan ditampilkan di area ini.',
    imageUrl: '',
    linkUrl: '/berita',
  },
  partners: [
    { id: 'partner-001', name: 'Mitra Pelatihan', iconUrl: '' },
    { id: 'partner-002', name: 'Mitra Bahasa', iconUrl: '' },
    { id: 'partner-003', name: 'Mitra Penempatan', iconUrl: '' },
  ],
};

export const fallbackAboutContent = {
  profile: {
    eyebrow: 'Tentang LPK Furusato Temanggung',
    title: 'LPK FURUSATO TEMANGGUNG',
    body: 'Furusato adalah lembaga pelatihan kerja yang ikut berperan mengembangkan potensi sumber daya manusia Indonesia agar siap memasuki dunia kerja profesional, khususnya peluang kerja ke Jepang.',
  },
  chairman: {
    eyebrow: 'Sambutan Ketua',
    name: 'Ketua LPK Furusato Temanggung',
    body: 'Kami berkomitmen memberikan pelatihan, pendampingan, dan pembinaan terbaik agar peserta tidak hanya siap bekerja, tetapi juga mampu membawa sikap disiplin, tangguh, dan bertanggung jawab.',
    imageUrl: '',
  },
  visionMission: {
    visionTitle: 'VISI',
    vision: 'Menjadi lembaga pelatihan kerja yang dapat dipercaya, terbukti, dan bertanggung jawab dalam menyiapkan peserta menuju karier yang lebih baik.',
    missionTitle: 'MISI',
    mission: 'Mencetak sumber daya manusia yang berkualitas dan bersaing.\nMemberikan pelatihan bahasa, budaya kerja, dan karakter secara terarah.\nMenjalin kerja sama yang baik dengan mitra dan peserta.',
  },
  programs: [
    {
      id: 'program-001',
      title: 'Program Bahasa Jepang',
      description: 'Pembelajaran bahasa Jepang terarah untuk membantu peserta membangun kemampuan komunikasi dasar.',
      imageUrl: '',
    },
    {
      id: 'program-002',
      title: 'Pembinaan Budaya Kerja',
      description: 'Pembinaan kedisiplinan, etika kerja, dan kesiapan mental untuk memasuki lingkungan kerja profesional.',
      imageUrl: '',
    },
    {
      id: 'program-003',
      title: 'Persiapan Seleksi',
      description: 'Pendampingan dokumen, wawancara, dan simulasi seleksi agar peserta lebih siap mengikuti tahapan kerja.',
      imageUrl: '',
    },
  ],
  slogan: {
    eyebrow: 'Langkah Kecilmu Hari Ini',
    title: 'Bisa sampai ke Jepang esok hari.',
    buttonText: 'Hubungi Kami',
    buttonUrl: '/kontak',
  },
};
